import { OrderLineType } from '../../order/models/order-line-type';
import { OrderLine } from '../../order/models/order-line';
import { GlobalSettings } from '../../../../environments/global-settings';
import { Partner } from '../../partner/models/partner';
import { BookingSlot } from './booking-slot';
import { environment } from '../../../../environments/environment';
import { BookingOrderService } from '../services/booking-order.service';
import { ShopSettingsService } from '../../general/services/shop-settings.service';

export class EventBookingCache {

  private _minPersonCount: number;
  private _maxPersonCount: number;

  private _personCount: number = null;
  private _eventOrderLine: OrderLine = null;
  private _guestOfHonor: Partner = null;
  private _bookingSlot: BookingSlot = null;

  private _invalidReason: string;

  constructor(
    private bookingOrderService: BookingOrderService,
    private shopSettingsService: ShopSettingsService,
  ) {
    this._minPersonCount = environment.globalSettings.eventMinPersonCount;
    this._maxPersonCount = environment.globalSettings.eventMaxPersonCount;
  }

  get minPersonCount(): number {
    return this._minPersonCount;
  }

  get maxPersonCount(): number {
    const maxPersonCount = this.shopSettingsService.shopSettings && this.shopSettingsService.shopSettings.eventTicketsMaximumQuantity ? this.shopSettingsService.shopSettings.eventTicketsMaximumQuantity : this._maxPersonCount;
    return maxPersonCount;
    // if (!this.bookingOrderService.selectedBookingSlots) {
    //   this.updateInvalidReason();
    //   return 0;
    // }
    // const bookingSlotMaxCapacity = Math.max.apply(
    //   Math,
    //   this.bookingOrderService.selectedBookingSlots
    //     .map(x => x.capacity)
    // );

    // let eventTicketsMaximumQuantity = 0;
    // if (this.bookingOrderService.shopSettings && this.bookingOrderService.shopSettings.eventTicketsMaximumQuantity) {
    //   eventTicketsMaximumQuantity = this.bookingOrderService.shopSettings.eventTicketsMaximumQuantity;
    // }

    // if (bookingSlotMaxCapacity > eventTicketsMaximumQuantity && eventTicketsMaximumQuantity !== 0) {
    //   return eventTicketsMaximumQuantity;
    // }

    // return bookingSlotMaxCapacity;
  }

  get eventOrderLine(): OrderLine {

    if (this._eventOrderLine) {
      return this._eventOrderLine;
    }

    this._eventOrderLine = this._stayInOrderOnlyEventOrderLine();
    return this._eventOrderLine;
  }

  get personCount(): number {
    return this.eventOrderLine.quantity;
  }

  set personCount(count: number) {
    const productVals = {
      'id': this.eventOrderLine.productId,
      'price': this.bookingOrderService.selectedAreaItem.price,
      'qty': count,
      // 'categId': areaItemTemp.categId,
      'productPriceSchedules':  this.bookingOrderService.selectedAreaItem.productPriceSchedules,
    };
    const price = this.bookingOrderService.computePriceByProductVals(productVals);

    this.eventOrderLine.quantity = count;
    this.eventOrderLine.price = price;


    this._selectBookingSlot(count);
  }

  get guestOfHonor(): Partner {
    if (!this._guestOfHonor) {
      this._guestOfHonor = new Partner();
    }
    return this._guestOfHonor;
  }

  update() {
    this._selectBookingSlot(this.personCount);
  }

  get bookingSlot(): BookingSlot {
    return this._bookingSlot;
  }

  private _selectBookingSlot(count: number) {
    if (!this.bookingOrderService.selectedBookingSlots) {
      this.updateInvalidReason();
      return;
    }
    const sortedBookingSlots = this.bookingOrderService.selectedBookingSlots
      .filter(x => x.capacity >= count)
      .sort(x => x.capacity);
    this._bookingSlot = sortedBookingSlots.length !== 0 ? sortedBookingSlots[0] : null;

    this.eventOrderLine.bookingSlotId = this.bookingSlot ? this.bookingSlot.id : null;
    const order = this.bookingOrderService.order;
    order.bookingDate = this.bookingOrderService.selectedBookingDate;
  }

  private _stayInOrderOnlyEventOrderLine(): OrderLine {
    if (!this.bookingOrderService.selectedAreaItem) {
      this.updateInvalidReason();
      return;
    }
    const productId = this.bookingOrderService.selectedAreaItem.productId;
    const order = this.bookingOrderService.order;

    const foundLines = order.orderLines.filter(x => x.orderLineType === OrderLineType.EventProduct);
    let foundLine: OrderLine;

    foundLines.forEach(item => {
      if (item.productId !== productId || foundLine !== null) {
        order.deleteOrderLine(item);
      } else {
        foundLine = item;
      }
    });

    if (!foundLine) {
      const price = this.bookingOrderService.computePriceByAreaItem(this.bookingOrderService.selectedAreaItem,  this._minPersonCount);
      foundLine = order.addOrderLine(
        OrderLineType.EventProduct,
        this.bookingOrderService.selectedAreaItem.name || this.bookingOrderService.selectedAreaItem.productName,
        productId,
        price,
        this.bookingOrderService.selectedAreaItem.taxRate,
        this._minPersonCount,
        true,
        this.bookingSlot ? this.bookingSlot.id : null
      );
    }

    order.sortOrderLines();

    return foundLine;
  }

  reset() {
    this._personCount = null;
    this._eventOrderLine = null;
    this._guestOfHonor = null;
    this._bookingSlot = null;
    this._invalidReason = null;
  }

  updateInvalidReason(invalidReasons: Array<string> = null) {
    if (!invalidReasons) {
      invalidReasons = new Array<string>();
    }
    if (!this.bookingOrderService.selectedAreaItem) {
      invalidReasons.push(`Not possible to find product type for this event!`);
    }
    if (!this.bookingOrderService.selectedBookingSlots) {
      invalidReasons.push(`No more free places at this time!`);
    }

    this._invalidReason = invalidReasons.join(' ,');
  }

  get invalidReason(): string {
    return this._invalidReason;
  }
}
